"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useRef } from "react";
interface UseChatScrollOptions {
  chatId: string | null | undefined;
  messagesLength: number;
  isLoading: boolean;
}
interface UseChatScrollReturn {
  chatContainerRef: React.RefObject<HTMLDivElement | null>;
  scrollToBottom: (smooth?: boolean) => void;
}
export function useChatScroll(t0) {
  const $ = _c(9);
  const {
    chatId,
    messagesLength,
    isLoading
  } = t0;
  const chatContainerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const smooth = t2 === undefined ? false : t2;
      if (!chatContainerRef.current) {
        return;
      }
      const container = chatContainerRef.current;
      container.scrollTo({
        top: container.scrollHeight,
        behavior: smooth ? "smooth" : "instant"
      });
      requestAnimationFrame(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTo({
            top: chatContainerRef.current.scrollHeight,
            behavior: smooth ? "smooth" : "instant"
          });
        }
      });
      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTo({
            top: chatContainerRef.current.scrollHeight,
            behavior: smooth ? "smooth" : "instant"
          });
        }
      }, 100);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const scrollToBottom = t1;
  let t2;
  if ($[1] !== isLoading || $[2] !== messagesLength) {
    t2 = () => {
      if (messagesLength > 0 && !isLoading) {
        scrollToBottom();
      }
    };
    $[1] = isLoading;
    $[2] = messagesLength;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== chatId || $[5] !== isLoading || $[6] !== messagesLength) {
    t3 = [messagesLength, chatId, scrollToBottom, isLoading];
    $[4] = chatId;
    $[5] = isLoading;
    $[6] = messagesLength;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      chatContainerRef,
      scrollToBottom
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}